fx.ns("shared.popups", class LoginPopup extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personSure);
        this.contentWidth = 400;
        // taller when the browser social buttons are shown (hidden in the app webview)
        this.contentHeight = fx.get("flutter") ? 345 : 470;
        this.effect = "";
    }

    create()
    {
        super.create();

        // title
        this.addChild(new fx.components.Text({text:fx.text("Connectez-vous"), className:"title"}));

        // inputs
        this.loginInput = new fx.components.Input({placeHolder:fx.text("Votre email")});
        this.addChild(this.loginInput, {height:60, width:"100%"});
        this.passwordInput = new fx.components.Input({placeHolder:fx.text("Votre mot de passe"), name:"password", type:"password"});
        this.addChild(this.passwordInput, {height:60, width:"100%"});

        // error
        this._error = new fx.components.Text({className:"error"});
        this.addChild(this._error, {width:"100%", height:26});

        // social sign-in (browser only; the app webview uses the native auth modal)
        if (!fx.get("flutter"))
        {
            this.addChild(new fx.components.Text({text:fx.text("OU"), className:"or-separator"}), {width:"100%", height:22});

            this.googleButton = new fx.components.Button({label:fx.text("Continuer avec Google"), type:"borderOnly", className:"social-login-btn social-login-btn--google"});
            this.addChild(this.googleButton, {width:"100%", height:44});

            this.appleButton = new fx.components.Button({label:fx.text("Continuer avec Apple"), type:"borderOnly", className:"social-login-btn social-login-btn--apple"});
            this.addChild(this.appleButton, {width:"100%", height:44});
        }

        // new registration string
        this.registration = new fx.components.Text({text:fx.text("Vous ne possedez pas encore de compte ?"), className:"link account-switch"});
        this.addChild(this.registration, {width:"100%"});

        this.okButton = new fx.components.Button({label : fx.text("Se connecter"), type : "filled"});
        this.addFooterChild(this.okButton, {width : 200});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("enter", this.onConfirm, this.loginInput);
        this.on("enter", this.onConfirm, this.passwordInput);
        this.on("click", this.onRegistration, this.registration);

        if (this.googleButton) this.on("click", this.onGoogle, this.googleButton);
        if (this.appleButton) this.on("click", this.onApple, this.appleButton);

        this.loginInput.focus();
    }

    onGoogle()
    {
        this._socialLogin("google");
    }

    onApple()
    {
        this._socialLogin("apple");
    }

    _socialLogin(provider)
    {
        this.loading(true, fx.text("Connexion"));

        window.flxSocialAuth.login(provider, {
            creationid : this.data.creation.id,
            accountid  : this.data.account.id,
            onResult   : (resp) => this._onSocialResult(resp),
        });
    }

    _onSocialResult(resp)
    {
        if (resp && resp.ok && resp.user)
        {
            // reuse the normal login path: _logged seeds the model and emits
            // "login-succeed", handled in onDataEvent (closes + login-complete).
            this.data.account._logged(resp.user);
        }
        else
        {
            this.loading(false);
            this._error.text = fx.text("La connexion n'a pas abouti. Veuillez réessayer.");
        }
    }

    onRegistration()
    {
        this.close();
        this.data.event("register-user");
    }

    onConfirm()
    {
        if (!Utils.validateEmail(this.loginInput.value))
        {
            this._error.text = fx.text("Le format de votre email est incorrect");
        }
        else
        if (this.passwordInput.value.length < 6)
        {
            this._error.text = fx.text("Votre mot de passe doit contenir au moins 6 caractères");
        }
        else
        if (this.loginInput.value && this.passwordInput.value)
        {
            this.connect( this.loginInput.value, this.passwordInput.value);
        }
        else
        {
            this._error.text = fx.text("Veuillez saisir votre email et mot de passe");
        }
    }

    connect(email, password)
    {
        this.loading(true, fx.text("Connexion"));

        this.data.account.login(email, password, this.data.creation.id, this.data.account.id);
        
    }

    onDataEvent(event)
    {
        super.onDataEvent(event);
        
        switch(event.type)
        {
            case "login-succeed": 
            //case "update-url-error" :
            //case "update-url-complete" :
                this.close();
                this.loading(false);
                this.data.event("login-complete");
                break;

            case "login-failed" :
                this.loading(false);
                this._error.text = fx.text("Email ou mot de passe incorrect");
                this.passwordInput.value = '';
            break;
        }
    }

});